import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import {
  ImageCms,
  ImageSectionCms,
} from '~/cms/interfaces/homepage.cms.interface';
import { BreakpointWidthEnum } from '~/core/enums/breakpoint-width.enum';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';
@Component({
  selector: 'app-cms-image-section',
  templateUrl: './image-section.component.html',
})
export class CmsImageSectionComponent implements OnInit, OnDestroy {
  @Input() public section: ImageSectionCms;

  private readonly subscriptions = new Subscription();

  public isMobileDevice: boolean;

  constructor(private readonly matchMediaService: MatchMediaService) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public get alt(): string {
    return this.image.alternativeText;
  }

  public get image(): ImageCms {
    return this.isMobileDevice ? this.section.mobile : this.section.desktop;
  }

  public get mediaMediumBreakpoint(): string {
    return `(min-width: ${BreakpointWidthEnum.MD}px)`;
  }
}
